export const SET_GUARDIAN_STATE = 'SET_GUARDIAN_STATE';
export const SET_GUARDIAN_HYDRATED = 'SET_GUARDIAN_HYDRATED';
export const UNLOCK_GUARDIAN = 'UNLOCK_GUARDIAN';
export const SET_SELECTED_GUARDIAN = 'SET_SELECTED_GUARDIAN';
export const SET_GUARDIAN_PURCHASING = 'SET_GUARDIAN_PURCHASING';
export const SET_GUARDIAN_ERROR = 'SET_GUARDIAN_ERROR';
export const RESET_GUARDIANS = 'RESET_GUARDIANS';
